import apiPath from "./apiPath";
import { isEmpty } from "lodash";
import validator from "validator";
var helper = {
  getBages: function (status) {
    return status === "active"
      ? "success"
      : status === "inactive"
      ? "warning"
      : status === "deleted"
      ? "danger"
      : "primary";
  },
  serialize: function (obj, prefix) {
    var str = [];
    var p;
    for (p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p,
          v = obj[p];
        str.push(
          v !== null && typeof v === "object"
            ? this.serialize(v, k)
            : encodeURIComponent(k) + "=" + encodeURIComponent(v)
        );
      }
    }
    return str.join("&");
  },
  getBase64: function (file, cb) {
    let reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = function () {
        cb(reader.result);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    }
  },
  getDefaultCarImage: function (event) {
    event.target.src = `${apiPath.baseURL}img/v/default-no-car.png`;
  },
  validatePassword: function (value) {
    if (!isEmpty(value)) {
      return validator.isLength(value, { min: 6 });
    } else {
      return true;
    }
  },
  mobileWithoutCodeView: function (number = "") {
    if (number) {
      return number.indexOf("+1") === 0 ? number.replace("+1", "") : number;
    } else {
      return "";
    }
  },
  mobileWithCode: function (number = "") {
    if (number) {
      return number.indexOf("+1") === -1 ? `+1${number}` : `${number}`;
    } else {
      return "";
    }
  },
  getMonth: function () {
    var fromDateMonth = new Date();
    var fromMonth =
      fromDateMonth.getMonth() + 1 < 10
        ? "0" + (fromDateMonth.getMonth() + 1)
        : fromDateMonth.getMonth() + 1;
    var stringMonth = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nav",
      "Dec",
    ];
    let currentYearData = [];
    for (var i = 1; i <= 12; i++) {
      var months = stringMonth[i - 1];
      var month = i < 10 ? "0" + i : i;
      if (fromMonth >= month) {
        currentYearData.push(months);
      }
    }
    return currentYearData;
  },
  getWeek: function () {
    var stringMonth = ["Mon", "Tus", "Wed", "Thr", "Sat", "Sun"];
    return stringMonth;
  },
};
export default helper;
